<template>
  <section class="portrait-summary" data-portrait-summary>
    <strong>客户画像与服务标记</strong>
    <el-button type="text" class="portrait-log-link" @click="$emit('view-logs')">查看完整标记日志</el-button>
    <p v-if="loading">正在加载画像与服务标记…</p>
    <div v-else-if="error">
      <span>{{error}}</span><el-button type="text" @click="load">重新加载</el-button>
    </div>
    <template v-else-if="summary">
      <div class="portrait-summary-fields">
        <span>当前画像：{{portraitText}}</span>
        <span>当前服务周期：{{cycleText}}</span>
        <span>累计符合次数：{{summary.markCount || 0}}</span>
      </div>
      <div v-if="summary.latestMarkedAt" class="portrait-summary-meta">
        最近画像标记：{{timeText(summary.latestMarkedAt)}}<span v-if="summary.latestMarkedByName"> · {{summary.latestMarkedByName}}</span>
        <span v-if="summary.portraitExpireAt"> · 画像有效至：{{timeText(summary.portraitExpireAt)}}</span>
      </div>
    </template>
  </section>
</template>
<script>
import portraitApi from '@/api/client/customerPortrait'
import { portraitConclusionText, serviceCycleText } from '@/utils/customerPortrait'
import dayjs from 'dayjs'
export default {
  props: { customerId: { type: [Number, String], required: true } },
  data() { return { summary: null, loading: false, error: '' } },
  computed: {
    portraitText() {
      if (this.summary.portraitValid) return '符合3.0及以上画像 · 有效'
      if (this.summary.latestIsPortrait30 === true) return '曾标记符合 · 已到期'
      return portraitConclusionText(this.summary.latestIsPortrait30)
    },
    cycleText() { return serviceCycleText(this.summary.serviceCycle) }
  },
  watch: { customerId: { immediate: true, handler: 'load' } },
  methods: {
    timeText(value) { const time = dayjs(value); return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : '--' },
    async load() {
      const version = this._portraitRequestVersion = (this._portraitRequestVersion || 0) + 1
      this.summary = null; this.error = ''; this.loading = Boolean(this.customerId)
      if (!this.customerId) return
      try {
        const { data } = await portraitApi.summary(this.customerId)
        if (version === this._portraitRequestVersion) this.summary = data || null
      } catch (e) { if (version === this._portraitRequestVersion) this.error = '画像与服务标记加载失败，请重试' }
      finally { if (version === this._portraitRequestVersion) this.loading = false }
    }
  }
}
</script>
<style scoped>
.portrait-summary { border: 1px solid #dce9f5; background: #f5faff; padding: 14px 16px; margin-top: 16px; line-height: 1.8; }
.portrait-summary-fields { display: flex; flex-wrap: wrap; gap: 16px 32px; margin-top: 8px; }
.portrait-summary-meta { color: #606266; font-size: 12px; margin-top: 6px; }
.portrait-log-link { float: right; padding: 3px 0; }
</style>
